const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
  cartRender: "cart-render",
  productChange: "product-change",
  variantChangePi: "pi-variant-change",
  collectionRender: "collection-render",
};
// For PIConfig
const PIConfig = {} || PIConfig;
PIConfig.cache = [];
